"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _Card = require("./Card.styles");
var _CardSection = require("./partials/CardSection");
var _jsxRuntime = require("react/jsx-runtime");
var Card = function Card(props) {
  var children = props.children;
  var styles = (0, _Card.useStyles)(props);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-Card'],
    children: children
  });
};
exports.Card = Card;
Card.Section = _CardSection.CardSection;